import styled from 'styled-components'
export const Container = styled.div`
  position: relative;
  width: 100vw;
  height: ${p => (p.vh * 100)}px;
  background: #2b471f;
  overflow: hidden;
`

export const ContainerLogo = styled.div`
  position: absolute;
  top: ${p => p.screenSize === 'mobile' ? '20px': '52px'};
  left: 50%;
  transform: translateX(-50%);
  width: 82px;
  height: 54px;
  z-index: 20;
  transition: left .6s cubic-bezier(0.59,-0.01, 0.29, 0.96);

  > div {
    padding-top: 0;
    width: 82px !important;
  }

  @media (min-width: 768px) {
    width: 118px;
    height: 69px;

    > div {
      width: initial !important;
    }
  }

  &.middle {
    left: 50.4%;
  }

  &.amorin {
    left: 60%;
  }

  &.wicanders {
    left: 40%;
  }
`